import firebase from 'firebase';

var config = {
    apiKey: "AIzaSyC6KqMxuR6fClQJggnt41fz6wbuL9-96lo",
    authDomain: "learning-portal-6b7d6.firebaseapp.com",
    databaseURL: "https://learning-portal-6b7d6.firebaseio.com",
    projectId: "learning-portal-6b7d6",
    storageBucket: "learning-portal-6b7d6.appspot.com",
    messagingSenderId: "915797726787"
  };
  const fb = firebase.initializeApp(config);
  const secondaryfb = firebase.initializeApp(config, 'Secondary');
  const creds = { 
    'fb': fb,
    'secondaryfb': secondaryfb
  }
  export default creds;
 




// WEBPACK FOOTER //
// ./src/config/firebaseConfig.js